import React, { Children } from 'react';
import useAmplitudeClient from './useAmplitudeClient';

export default function Amplitude({ children }) {
  const client = useAmplitudeClient();
  return children({
    logEvent: client.logEvent,
    instrument: (eventName, callback, eventProperties) => {
      return (...args) => {
        client.logEvent(eventName, eventProperties);
        callback && callback(...args);
      };
    }
  });
}
